import React, { useEffect, useState } from 'react'
import './styles.less'
import NpsScale, { getNpsCategory, NpsCategory } from './NpsScale'
import { checkNpsEligibility, getNpsSiteId, sendNpsResponse, NPS_INTERACTION_EVENT } from './npsSurvey.service'

type Props = {
    site_name: string;
    country_code: string;
}

const NpsSurveyCard = ({ site_name, country_code }: Props) => {
    const siteId = getNpsSiteId(site_name, country_code)
    const [visible, setVisible] = useState<boolean>(false)
    const [score, setScore] = useState<number | undefined>(undefined)
    const [category, setCategory] = useState<NpsCategory | undefined>(undefined)
    const [comment, setComment] = useState<string>("")
    const [sent, setSent] = useState<boolean>(false)
    const [sending, setSending] = useState<boolean>(false)
    const [dismissed, setDismissed] = useState<boolean>(false)

    useEffect(() => {
        // Una vez que el usuario cierra o completa el formulario, no lo reabrimos
        // automáticamente por el resto de esta carga de página.
        if (!siteId || dismissed || sent) return
        let cancelled = false
        const evaluate = () => {
            checkNpsEligibility(siteId).then((isEligible) => {
                if (cancelled) return
                setVisible(isEligible)
            })
        }
        evaluate()
        // SearchPage no remonta entre búsquedas, solo re-renderiza: sin este listener
        // el card no se entera de que se alcanzó el umbral hasta un refresh completo.
        window.addEventListener(NPS_INTERACTION_EVENT, evaluate)
        return () => {
            cancelled = true
            window.removeEventListener(NPS_INTERACTION_EVENT, evaluate)
        }
    }, [siteId, dismissed, sent])

    const getFormTitleByScore = (category: NpsCategory) => {
        if (category === "detractor") return "Lamentamos la experiencia. ¿Qué salió mal?"
        if (category === "pasivo") return "Gracias. ¿Qué podríamos mejorar para encantarte?"
        return `¡Genial! ¿Qué es lo que más te gusta de ${site_name}?`
    }
    const onBack = ()=>{
        setCategory(undefined)
        setScore(undefined)
    }
    const onClose = () => {
        if (!sent && !sending) {
            sendNpsResponse(siteId, undefined, "", true)
        }
        setDismissed(true)
        setVisible(false)
    }
    const onSend = async () => {
        if (score === undefined || sending) return
        setSending(true)
        const success = await sendNpsResponse(siteId, score, comment.trim())
        setSending(false)
        if (success) {
            setSent(true)
        }
    }
    if (!siteId || !visible) return null
    return (
        <div className="npsSurveyCard">
            <div className="npsSurveyCard__card">
                <div className="npsSurveyCard__card__layout">
                    <button className="npsSurveyCard__card__layout__close" onClick={onClose}>
                        x
                    </button>
                    <div className="npsSurveyCard__card__layout__body">
                        {sent ? (
                            <div className="npsSurveyCard__thanks">
                                <div className="npsSurveyCard__thanks__icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                </div>
                                <h2 className="npsSurveyCard__thanks__title">¡Gracias por tu opinión!</h2>
                                <p className="npsSurveyCard__thanks__text">Nos ayudas a mejorar {site_name} para toda la comunidad.</p>
                                <button className="npsSurveyCard__thanks__close" onClick={onClose}>Cerrar</button>
                            </div>
                        ) : score !== undefined ? (
                            <div className="npsSurveyCard__card__layout__body--content">
                                <div className='npsSurveyCard__formheader'>
                                    <div className={`npsSurveyCard__formheader__score npsScale__option--selected npsScale__option--${getNpsCategory(score)}`}>
                                        {score}
                                    </div>
                                    <div className='npsSurveyCard__formtitle'>
                                        <h2>{getFormTitleByScore(category)}</h2>
                                        <p>Tu respuesta es anónima.</p>
                                    </div>
                                </div>
                                <textarea
                                    id="npssurvey-comment"
                                    name="npssurvey-comment"
                                    className='npsSurveyCard__formcomment'
                                    placeholder='Cuéntanos un poco más (opcional)…'
                                    aria-label='Comentario adicional (opcional)'
                                    rows={3}
                                    maxLength={1000}
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                                <p className='npsSurveyCard__disclaimer'>Tu respuesta es anónima</p>
                                <div className='npsSurveyCard__footer'>
                                    <button className='npsSurveyCard__footer--back' onClick={onBack} disabled={sending}>← Cambiar puntuación</button>
                                    <button className='npsSurveyCard__footer--send' onClick={onSend} disabled={sending}>{sending ? "Enviando…" : "Enviar"}</button>
                                </div>
                            </div>
                        ) :
                            (
                                <div className="npsSurveyCard__card__layout__body--content">
                                    <h2>¿Qué tan probable es que recomiendes {site_name} a un amigo o colega?</h2>
                                    <NpsScale
                                        onChange={(score, category) => {
                                            setScore(score)
                                            setCategory(category)
                                        }}
                                    />
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NpsSurveyCard